import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const PRODUCT_CARD_WIDTH = '1/3';
export const PRODUCT_CARD_PADDING = '$1';
export const DEFAULT_PRODUCT_CARD_HEIGHT_MOBILE = 180;
export const DEFAULT_PRODUCT_CARD_HEIGHT_DESKTOP = 190;

export const ProductCardContainer = Box.withConfig<{
  $isSelected: boolean;
  $isFlipped?: boolean;
}>(({ $isSelected, $isFlipped }) => ({
  backgroundColor: primitive.$white,
  alignItems: 'center',
  borderWidth: 2,
  borderColor: $isSelected ? primitive.$bbqBrown : primitive.$blackOpacity10,
  borderStyle: 'solid',
  borderRadius: primitive.$borderRadius,
  overflow: 'hidden',
  minHeight: {
    base: '$40',
  },
  padding: {
    base: $isFlipped ? '$0' : '$2',
  },
}));

export const ProductCardImageContainer = Box.withConfig({
  flex: 1,
  width: 'full',
  padding: 0,
  margin: 0,
  alignItems: 'center',
  justifyContent: 'center',
});

export const ProductCardBadge = Box.withConfig({
  position: 'absolute',
  right: 2,
  top: 2,
  zIndex: 2,
});

export const ProductCardBadgeLeft = Box.withConfig({
  position: 'absolute',
  left: 2,
  top: 2,
  zIndex: 2,
});

export const ProductCardContent = Box.withConfig({
  width: 'full',
  height: '80px',
});

export const ProductNameContainer = Box.withConfig({
  flexGrow: 1,
  justifyContent: 'center',
  alignItems: 'center',
});

export const ProductCardFooter = Box.withConfig({
  flex: 1,
  width: 'full',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const ProductCardOptionsContainer = Box.withConfig({
  flex: 1,
  width: 'full',
});

export const ProductCardReverseContainer = Box;
